import { put, takeEvery, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListSearchPropertyPayload } from '@app-store/slices/properties/listSearch'

interface TaskAction extends Action {
    payload: IListSearchPropertyPayload
}

const { onRequest, onSuccess, onFailure, onRequestList, onSuccessPageList } = rootActions.properties.listSearch

function* listSearchPropertySagaTask({ payload }) {
    const params = yield getParams({ ...payload, addPresignedURL: true })
    try {
        const response = yield axios.get(`/attachments/properties`, {
            params
        })
        if (response.success) {
            yield payload.sagaCB?.onSuccess(response.result)
            yield put(onSuccess({ keepOldData: payload.keepOldData || false, ...response.result }))
            yield put(onSuccessPageList(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSearchPropertySaga(): any {
    yield takeEvery<TaskAction>(onRequestList, listSearchPropertySagaTask)
    yield takeLatest<TaskAction>(onRequest, listSearchPropertySagaTask)
}

export default listSearchPropertySaga
